var _rect, _polygon, _rect2, _rect3, _line, _line2, _line3, _line4, _path, _path2, _path3, _line5, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKbDesignerIcoPositiveEnvelopeDiagonalAscend(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Black_bez_okraje",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.71,
    y: 16.15,
    width: 7.22,
    height: 5.61,
    fill: "#fbba00",
    strokeWidth: 0
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "14.86 28.53 18.4 28.53 18.4 22.92 13.67 22.92 14.86 28.53",
    fill: "#fbba00",
    strokeWidth: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.04,
    y: 11.97,
    width: 6.35,
    height: 4.37,
    fill: "#fbba00",
    strokeWidth: 0
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.89,
    y: 8.5,
    width: 4.44,
    height: 2.84,
    fill: "#fbba00",
    strokeWidth: 0
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 31.42,
    y1: 16.23,
    x2: 17.08,
    y2: 16.23,
    fill: "#fbba00",
    stroke: "#030303",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 34.75,
    y1: 11.53,
    x2: 23.8,
    y2: 11.53,
    fill: "#fbba00",
    stroke: "#030303",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 19.4,
    y1: 28.61,
    x2: 15.47,
    y2: 28.61,
    fill: "#fbba00",
    stroke: "#030303",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 12.39,
    y1: 22.48,
    x2: 24.01,
    y2: 22.48,
    fill: "#fbba00",
    stroke: "#030303",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.24,37.79v2.94h-2.46v-2.94h2.46M27.24,35.79h-6.46v6.94h6.46v-6.94h0Z",
    fill: "#030303",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.01,8.31c10.74,0,13.01,7.53,11.18,12.24-2.27,5.84-5.45,10-9.63,14.65h-3.08c-4.29-4.52-7.14-8.35-9.63-14.65-1.86-4.7.44-12.24,11.18-12.24M24.01,6.31c-6.95,0-10.35,2.85-11.97,5.24-1.92,2.82-2.33,6.55-1.07,9.73,2.67,6.74,5.7,10.71,10.04,15.29l.59.62h4.84l.6-.66c4.43-4.93,7.65-9.2,10.01-15.27,1.25-3.21.82-6.95-1.1-9.76-1.62-2.37-5.02-5.21-11.94-5.21h0Z",
    fill: "#030303",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.98,35.48s6.4-10.83,6.4-17.67c0-4.64-3.88-8.91-6.05-10.4",
    fill: "none",
    stroke: "#030303",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 8.09,
    x2: 24,
    y2: 35.48,
    fill: "none",
    stroke: "#030303",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.03,35.48s-6.4-10.83-6.4-17.67c0-4.64,3.88-8.91,6.05-10.4",
    fill: "none",
    stroke: "#030303",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbDesignerIcoPositiveEnvelopeDiagonalAscend);
export default __webpack_public_path__ + "static/media/kb-designer-ico-positive-envelope-diagonal-ascend.78a14a486eb3285c13816f6356ea127f.svg";
export { ForwardRef as ReactComponent };